import React from 'react';
import { priceFormat, formatOrderDateToLocalTime, formatCentsToDollars } from '../../../../util';
import {
  ResultCancelSubscriptionRow,
  ResultsCancelSubscriptionNameColumn,
  ResultsOrderNumber,
  ResultsCancelSubscriptionStatusColumn,
} from '../SearchResult.styles';
import { useSelector } from 'react-redux';
import { selectSubscriptionSystem } from 'selectors/tools';
import { SUBSCRIPTION_SYSTEMS } from 'constants/integrations';
import { Checkbox, CheckBoxContainer } from './CancelSubscriptionResult.styles';

const FormattedPrice = ({ subscription }) => {
  const subscriptionSystem = useSelector(selectSubscriptionSystem) || {};
  switch (subscriptionSystem) {
    case SUBSCRIPTION_SYSTEMS.SIMPLR_ORDER:
      return <span>{priceFormat(formatCentsToDollars(subscription.price))}</span>;
    default:
      return null;
  }
};

/**
 * @param {SubscriptionModel} result
 * @param {Function} clickAction
 * @param checked
 * @constructor
 */
const CancelSubscriptionResult = ({ result, clickAction, checked }) => {
  const titleOrSku = result.variant_title || result.sku;

  return (
    <ResultCancelSubscriptionRow>
      <CheckBoxContainer>
        <Checkbox type="checkbox" checked={checked} onChange={() => clickAction(result)} />
      </CheckBoxContainer>
      <ResultsCancelSubscriptionNameColumn>
        <ResultsOrderNumber>
          {result.quantity} x {result.product_title}
        </ResultsOrderNumber>
        <span> - </span>
        <span>{titleOrSku}</span>
        <span> - </span>
        <FormattedPrice subscription={result} />
      </ResultsCancelSubscriptionNameColumn>
      <ResultsCancelSubscriptionStatusColumn>
        {formatOrderDateToLocalTime(result.created_at, 'shopify')}
      </ResultsCancelSubscriptionStatusColumn>
      <ResultsCancelSubscriptionStatusColumn active={result.status === 'ACTIVE'}>
        {result.status}
      </ResultsCancelSubscriptionStatusColumn>
    </ResultCancelSubscriptionRow>
  );
};

export default CancelSubscriptionResult;
